import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-seleccion-sf',
  templateUrl: './seleccion-sf.component.html',
  styleUrls: ['./seleccion-sf.component.css'],
})
export class SeleccionSfComponent implements OnInit {

  safeUrl: SafeResourceUrl;
  
    constructor(
      private authService: AuthService,
      private sanitizer: DomSanitizer
    ) { }
  
    ngOnInit() {
      const acccessToken = this.authService.getToken();
  
      const iframeUrl = `${environment.ADMIN_URL}dashboard/seleccion?token=${acccessToken}`;
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
    }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/seleccion-sf/seleccion-sf.component.ts